"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import * as Aria from 'react-aria-components';
import formFieldStyles from '../FormField/FormField.module.scss.mjs';
import styles from './SearchField.module.scss.mjs';
import clsx from 'clsx';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import '../../lib/propsContext/propsContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { FieldError } from '../FieldError/FieldError.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { Button } from '../Button/Button.mjs';
import '@tabler/icons-react';
import '../Icon/Icon.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconClose } from '../Icon/components/icons/IconClose.mjs';
import { IconSearch } from '../Icon/components/icons/IconSearch.mjs';
import locales from '../../../../_virtual/_.locale.json@e940efc6da10fdf09417eb079b65a343.mjs';
import { useLocalizedStringFormatter } from 'react-aria';

const SearchField = flowComponent("SearchField", (props) => {
  const { children, className, ref, ...rest } = props;
  const rootClassName = clsx(
    formFieldStyles.formField,
    styles.searchField,
    className
  );
  const stringFormatter = useLocalizedStringFormatter(locales);
  const searchText = stringFormatter.format(`searchField.search`);
  const propsContext = {
    Label: {
      className: formFieldStyles.label,
      optional: !props.isRequired
    },
    FieldDescription: {
      className: formFieldStyles.fieldDescription
    },
    FieldError: {
      className: formFieldStyles.customFieldError
    }
  };
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsxs(
    Aria.SearchField,
    {
      "aria-label": searchText,
      ...rest,
      className: rootClassName,
      children: [
        /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children }),
        /* @__PURE__ */ jsxs("div", { className: styles.inputContainer, children: [
          /* @__PURE__ */ jsx(IconSearch, { className: styles.searchIcon }),
          /* @__PURE__ */ jsx(
            Aria.Input,
            {
              placeholder: searchText,
              className: styles.input,
              ref
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              className: styles.clearButton,
              variant: "plain",
              color: "secondary",
              children: /* @__PURE__ */ jsx(IconClose, {})
            }
          )
        ] }),
        /* @__PURE__ */ jsx(FieldError, { className: formFieldStyles.fieldError })
      ]
    }
  ) });
});

export { SearchField, SearchField as default };
//# sourceMappingURL=SearchField.mjs.map
